import { render, staticRenderFns } from "./CreateTemplateFromCubage.vue?vue&type=template&id=685163b0"
import script from "./CreateTemplateFromCubage.vue?vue&type=script&lang=js"
export * from "./CreateTemplateFromCubage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports